import {SummaryModel} from "../../../common/entity/summary.model";
import {PermissionsModel} from "../../../common/entity/permissions.model";

export class SubscriptionSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    providerServiceName: string;
    providerName: string;
    accountName: string;
    displayIndex: number;
}